/** Upload multiple assets for a KB article. Create new or replace existing. */
export const kbArticleAssetsSaveSpec = {
    uri: '/kb/article/[article]/assets',
    method: 'PUT',
    adminOnly: true,
};
